import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { InstagramLogo, TwitterLogo, LinkedinLogo, FacebookLogo } from '@phosphor-icons/react';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#161617] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4 group" data-testid="footer-logo" aria-label="PJR Travel — Inicio">
              <img
                src="/pjr-logo.png"
                alt="PJR Travel"
                className="h-10 w-auto object-contain transition-transform group-hover:scale-[1.02]"
                draggable="false"
              />
            </Link>
            <p className="text-white/50 text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="text-white/50 hover:text-white transition-colors"><InstagramLogo size={20} weight="fill" /></a>
              <a href="#" className="text-white/50 hover:text-white transition-colors"><TwitterLogo size={20} weight="fill" /></a>
              <a href="#" className="text-white/50 hover:text-white transition-colors"><LinkedinLogo size={20} weight="fill" /></a>
              <a href="#" className="text-white/50 hover:text-white transition-colors"><FacebookLogo size={20} weight="fill" /></a>
            </div>
          </div>
          <div>
            <h4 className="label-text text-white mb-4">{t('footer.support')}</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-white/50 hover:text-white text-sm transition-colors">{t('footer.contact')}</a></li>
              <li><a href="#" className="text-white/50 hover:text-white text-sm transition-colors">{t('footer.faq')}</a></li>
            </ul>
          </div>
          <div>
            <h4 className="label-text text-white mb-4">{t('footer.company')}</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-white/50 hover:text-white text-sm transition-colors">{t('footer.about')}</a></li>
              <li><a href="#" className="text-white/50 hover:text-white text-sm transition-colors">{t('footer.careers')}</a></li>
            </ul>
          </div>
          <div>
            <h4 className="label-text text-white mb-4">{t('footer.legal')}</h4>
            <ul className="space-y-3">
              <li><Link to="/privacidad" className="text-white/50 hover:text-white text-sm transition-colors" data-testid="footer-privacy-link">{t('footer.privacy')}</Link></li>
              <li><a href="#" className="text-white/50 hover:text-white text-sm transition-colors">{t('footer.terms')}</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-white/30 text-sm text-center">
            &copy; {new Date().getFullYear()} PJR Travel. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
